import { Typography } from "neetoui";
import { isEmpty } from "ramda";

import ElementContainer from "./ElementContainer";

const Section = ({
  title,
  elements,
  onSelect,
  isCreatable,
  disabledElementTooltip,
  isDragElementsDisabled: isDragDisabled,
  isDraggingOver,
  isAddingNewElement,
  setVisiblePanel,
}) => {
  if (isEmpty(elements)) {
    return null;
  }

  return (
    <>
      {title && <Typography className="mb-3 mt-1">{title}</Typography>}
      {elements.map(element => (
        <ElementContainer
          {...{
            disabledElementTooltip,
            element,
            isAddingNewElement,
            isCreatable,
            isDragDisabled,
            isDraggingOver,
            onSelect,
            setVisiblePanel,
          }}
          index={element.elementIndex}
          key={element.label}
        />
      ))}
    </>
  );
};

export default Section;
